<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.8418 28.875L25.082 31.6074L21.3105 27.2236C21.8882 25.8073 23.5132 23.8254 25.1709 22.8027L28.8418 28.875ZM32 19.2002C24.907 20.5973 18.988 25.2798 15.8887 31.6006L10.7129 28.2715C14.6312 20.9475 21.9531 15.7325 30.5586 14.7607L32 19.2002ZM22.3203 8.75L22.9111 15.7822C20.244 16.697 18.6751 17.4274 16.8779 18.5322C15.5511 19.3459 14.3443 20.2987 13.2646 21.3906L8 19.168L9.43555 14.7402L17.0176 16.5264L17.6719 8.75H22.3203Z"
      fill="#00C3A5"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
